import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import { PulseLoader } from 'halogenium';
import getFirebaseUIConfig from '../../app/User/Login/FirebaseLogin/FirebaseUiConfig';
import Axios from 'axios';

class LoginModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#login-modal-portal').length == 0) {
            $('body').prepend('<div id="login-modal-portal"></div>')
        }
        this.portalRoot = document.getElementById("login-modal-portal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        this.portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        this.portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}

let firebaseAuthUI = null

class LoginModal extends Component {
    constructor(props) {
        super(props);
        this.firebaseUIConfig = getFirebaseUIConfig(this.onFirebaseSignIn)

        let title = this.props.title == null? lang.encourage_sign_in : this.props.title;
        this.state = {
            hintText: <h4 style={{fontSize: "18px"}}>{title} </h4>,
        }
    }
    getLoggingInHint = () => {
        return <div>
            <h4 style={{textAlign:"center"}}>{lang.logging_in}</h4>
            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} />
        </div>
    }
    getLoggedInHint = () => {
        return <div>
            <h4 style={{textAlign:"center"}}>
                <i className="text-success mr-2 fas fa-check-circle"></i>
                <span>{lang.login_successful}</span>
            </h4>
        </div>
    }

    onFirebaseSignIn = (result, redirectURL) => {
        console.log(result, result.user)
        this.setState({
            hintText: this.getLoggingInHint()
        }, () => {
            Axios.post('/customer/firebase_login', {
                firebase_uid: result.user.uid,
                name: result.user.displayName,
                phone_number: result.user.phoneNumber,
                email: result.user.email,
            })
            .then((res) => {
                let customer = res.data
                
                // Set global field
                customerId = customer.id

                const customerData = {
                    firebase_uid: result.user.uid || '',
                    name: customer.name || '',
                    phone_number: customer.phone_number || '',
                    email: customer.email || '',
                }

                this.props.app.setState({
                    customer: customerData
                })

                this.setState({
                    hintText: this.getLoggedInHint()
                }, () => {
                    setTimeout(() => {
                        console.log(customerData)
                        this.props.onLoginSuccess && this.props.onLoginSuccess(customerData)
                    }, 500)
                })                
            }).catch((error) => console.log(error))
        })
        return false
    }

    loginWithFirebase(firebase_uid, callback) {
        Axios.get(`/customer/get?firebase_uid=${firebase_uid}`)
            .then((res) => {
                this.setState({
                    customer: {
                        firebase_uid: firebase_uid,
                        name: res.data.name,
                        phone_number: res.data.phone_number
                    }
                }, () => {
                    callback && callback()
                })
            })
    }

    componentWillUnmount() {
        firebaseAuthUI.delete()
        firebaseAuthUI = null
    }
    
    componentDidMount() {
        if (!firebaseAuthUI) {
            firebaseAuthUI = new firebaseui.auth.AuthUI(firebase.auth())
        }
        this.startFirebase()
    }
    startFirebase() {
        if ($('#firebaseui-login-container').length) {
            firebaseAuthUI.start('#firebaseui-login-container', this.firebaseUIConfig)
        }
    }

    onClose() {
        $("body").removeClass("modal-open");
        this.props.onClose && this.props.onClose()
    }

    // Event
    render() {
        return <LoginModalPortal>
            <Modal
                visible={true}
                closemodal={this.onClose.bind(this)}
                type="fadeInUp">
                <div className="login-modal" style={{padding:"10px", textAlign: "center"}}>
                    {this.state.hintText}
                    <div id='firebaseui-login-container'></div>
                    {/* <div style={{height: "350px"}}>
                    </div> */}
                </div>
            </Modal>
        </LoginModalPortal>
    }
}
LoginModal.defaultProps = {
    order: null
}
export default LoginModal;

